module.exports = __webpack_public_path__ + "media/theme/collection__dmm-32d7c7f0.png";